import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Skill } from "../../lib/types"
import { skills as initialSkillsData } from "../../constants"
import { v4 as uuidv4 } from "uuid"

interface SkillsState {
  items: Skill[]
}

const initialState: SkillsState = {
  items: initialSkillsData.map((skill: any) => ({
    ...skill,
    id: uuidv4(),
  })),
}

const skillsSlice = createSlice({
  name: "skills",
  initialState,
  reducers: {
    addSkill: (state, action: PayloadAction<Skill>) => {
      state.items.push(action.payload)
    },
    deleteSkill: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload)
    },
    updateSkill: (state, action: PayloadAction<Skill>) => {
      const index = state.items.findIndex((item) => item.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      }
    },
  },
})

export const { addSkill, deleteSkill, updateSkill } = skillsSlice.actions
export default skillsSlice.reducer
